<div class="card card-dashboard-element"
     [ngClass]="{ nested: nested }"
     [style.background]="hideBackground ? 'transparent' : ''">
    @if (!hideHeader) {
        <div class="card-header flex-column flex-lg-row justify-content-center justify-content-lg-start">
            <h3 data-test="dashboard-element-card-header">
                @if (linkObject) {
                    <a [routerLink]="linkObject.path"
                       [queryParams]="linkObject.queryParams"> {{ name }} <i class="fal fa-angle-right"></i> </a>
                } @else {
                    @if (hasClickSubscribers) {
                        <span class="clickable-header"
                              (click)="onHeaderClicked()"> {{ name }} <i class="fal fa-angle-right"></i> </span>
                    } @else {
                        {{ name }}
                    }
                }
                @if (info) {
                    <i class="ms-1 fal fa-circle-info"
                       [adaptTooltip]="info"></i>
                }
            </h3>
            <ng-container [ngTemplateOutlet]="projectedTitleContent"></ng-container>
            <div class="buttons btn-collection-transparent-pill text-end">
                <ng-container [ngTemplateOutlet]="projectedButtonsContent"></ng-container>
            </div>
        </div>
    }

    <div class="card-body">
        <ng-content></ng-content>
    </div>
</div>

<ng-template #projectedTitleContent>
    <ng-content select="[adapt-dashboard-title]"></ng-content>
</ng-template>

<ng-template #projectedButtonsContent>
    <ng-content select="[adapt-dashboard-title-buttons]"></ng-content>
</ng-template>
